export default __webpack_public_path__ + "images/unknown_18ca88.svg";